import { Box, Card, Container } from "@mui/material";
import React, { useState } from "react";
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import SymbolicationInfoTable from "pages/symbolicationManager/components/SymbolicationInfoTable";
import { SymbolicationState } from "src/dto/crashDetailsDto";

function SymbolicationInfoTabs() {
    const [menuIndex, setMenuIndex] = useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setMenuIndex(newValue);
    };

    return (
        <>
            <Container maxWidth={false} sx={{ mt: 4, ml: '20%', width: '60%' }}>
                <Card>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <Tabs
                            value={menuIndex}
                            onChange={handleChange}
                            TabIndicatorProps={{
                                style: {
                                    boxShadow: "none",
                                    backgroundColor: "white",
                                    borderColor: "lightgrey",
                                    borderBottom: 0,
                                    borderBottomLeftRadius: 0,
                                    borderBottomRightRadius: 0,
                                },
                            }}
                        >
                            <Tab
                                label={<span style={{ color: "black" }}>Symbolications In Progress</span>}
                                value={0}
                            />
                            <Tab
                                label={
                                    <span style={{ color: "black" }}>Symbolications In Queue</span>
                                }
                                value={1}
                            />
                            <Tab
                                label={<span style={{ color: "black" }}>Failed Symbolications</span>}
                                value={2}
                            />
                        </Tabs>
                    </Box>
                    <Box>
                        {menuIndex === 0 ? (
                            <Box>
                                <SymbolicationInfoTable symbolicationState={SymbolicationState.InProgress} />
                            </Box>
                        ) : null}
                        {menuIndex === 1 ? (
                            <Box>
                                <SymbolicationInfoTable symbolicationState={SymbolicationState.InQueue} />
                            </Box>
                        ) : null}
                        {menuIndex === 2 ? (
                            <Box>
                                <SymbolicationInfoTable symbolicationState={SymbolicationState.Failed} />
                            </Box>
                        ) : null}
                    </Box>
                </Card>
            </Container>
        </>
    )
}

export default SymbolicationInfoTabs;